import { type MealLibraryAction, MealLibraryActionTypes, type MealLibraryState } from './types'

export const initialMealLibraryState: MealLibraryState = {
  meals: [],
  userState: {},
  loading: true,
  error: null
}

export function mealLibraryReducer(state: MealLibraryState, action: MealLibraryAction): MealLibraryState {
  switch (action.type) {
    case MealLibraryActionTypes.SET_MEALS:
      // Meals are the authoritative subscription — their first snapshot clears loading.
      return { ...state, meals: action.payload, loading: false, error: null }
    case MealLibraryActionTypes.SET_USER_STATE:
      // User state is sparse and secondary; it never gates the loading flag.
      return { ...state, userState: action.payload }
    case MealLibraryActionTypes.SET_ERROR:
      return { ...state, loading: false, error: action.payload }
    case MealLibraryActionTypes.CLEAR:
      return { ...initialMealLibraryState }
    default:
      return state
  }
}
